/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(0, _module.loading)();
	
	//ページ内リンクのアニメーション
	//ローディング
	
	(0, _module.anchorScroll)();
	
	//ページTOP
	
	(0, _module.pageTop)();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var $window = $(window);
	var breakPoint = 767;
	
	var resizeFlag = false;
	var windowWidth = $window.width();
	var windowHeight = $window.height();
	//const bodyLimitHeight = (windowHeight - 185) * 0.88;
	
	var url = location.href;
	
	//ローディング
	var loading = function loading() {
	  var $target = $('#sw-Loading');
	  window.addEventListener('load', function () {
	    setTimeout(function () {
	      $target.fadeOut(600);
	    }, 1000);
	  });
	};
	
	//ページ内リンクのアニメーション
	var anchorScroll = function anchorScroll() {
	  var $anchor = $('a[href^=#]');
	  $anchor.click(function () {
	    var speed = 1000;
	    var href = $(this).attr('href');
	    var target = $(href == '#' || href == '' ? 'html' : href);
	    var position = target.offset().top;
	    $('html, body').animate({
	      scrollTop: position
	    }, speed, 'swing');
	    return false;
	  });
	};
	
	//ページTOP
	var pageTop = function pageTop() {
	  var topBtn = $('.sw-Top');
	  topBtn.hide();
	  $(window).scroll(function () {
	    if ($(this).scrollTop() > 100) {
	      topBtn.fadeIn();
	    } else {
	      topBtn.fadeOut();
	    }
	  });
	  topBtn.click(function () {
	    $('body,html').animate({
	      scrollTop: 0
	    }, 1000);
	    return false;
	  });
	};
	
	//export
	exports.loading = loading;
	exports.anchorScroll = anchorScroll;
	exports.pageTop = pageTop;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index/app.bundle.js